import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.addbtn)
      ? (_openBlock(), _createBlock(_component_ElSelect, {
          key: 0,
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          filterable: "",
          multiple: _ctx.multiple,
          clearable: !_ctx.multiple,
          size: _ctx.multiple?'default':'small',
          remote: "",
          "remote-method": _ctx.filterstyle,
          "reserve-keyword": "",
          placeholder: "请输入关键词",
          style: {"width":"100%"},
          loading: _ctx.loading,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change',_ctx.inputValue)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredstyles, (item) => {
              return (_openBlock(), _createBlock(_component_ElOption, {
                key: 'si'+item._id,
                label: item.name + ' ' +item.name_orig + ' / '+item.name_alt,
                value: item._id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "multiple", "clearable", "size", "remote-method", "loading"]))
      : (_openBlock(), _createBlock(_component_ElButton, {
          key: 1,
          class: "button-new-tag",
          size: "small",
          onClick: _ctx.showInput
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + ")
          ]),
          _: 1
        }, 8, ["onClick"]))
  ]))
}